exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-transport-baggage-info {\n  font-weight: bold;\n  font-size: 14px;\n}\n.dyna-transport-baggage-info__baggage-type-label {\n  font-size: 16px;\n  text-align: center;\n  border-bottom: 1px solid;\n  margin-bottom: 4px;\n  padding-bottom: 4px;\n}\n.dyna-transport-baggage-info__count-container {\n  white-space: nowrap;\n}\n.dyna-transport-baggage-info__count {\n  font-size: 28px;\n}\n.dyna-transport-baggage-info__icon {\n  display: inline;\n}\n.dyna-transport-baggage-info__no-bags .fas {\n  color: red;\n}\n", ""]);

// exports
